import { type FC } from "react";
import { FinancialPeriodBundle } from "../hooks/useFinancialsMetrics";
import { getDebtEquityValue } from "../utils/financialMetricValues";
import { FinancialMetricCard } from "./FinancialMetricCard";

export type DebtEquityCardProps = {
	recentFYE?: FinancialPeriodBundle;
};

export const DebtEquityCard: FC<DebtEquityCardProps> = ({ recentFYE }) => {
	const label = "Debt:Equity";
	const value = getDebtEquityValue(recentFYE);

	return <FinancialMetricCard testId="debt-equity-card" label={label} value={value} />;
};
